import {useTranslation} from "react-i18next";
import {FormLayout} from "../../components/guest/layout/form/FormLayout";
import {ForgotPasswordForm} from "../../components/guest/authentication/ForgotPasswordForm";

export const ForgotPassword = () => {
    const {t} = useTranslation("forgot");

    return (
        <FormLayout
            eyebrow={t("forgot:page-eyebrow")}
            title={<>
                {t("forgot:page-title-1")}<br/>
                {t("forgot:page-title-2")}<br/>
                <em>{t("forgot:page-title-3")}</em>
            </>}
            text={t("forgot:page-text")}>
            <ForgotPasswordForm/>
        </FormLayout>
    );
};